'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnimatedPageLoader = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function AnimatedPageLoader(_ref) {
  var hasBackground = _ref.hasBackground;
  var animatedLoaderClass = 'animated-loader animated-loader__page-loader';

  if (!hasBackground) {
    animatedLoaderClass += ' no-background';
  }

  return _react2['default'].createElement('div', {
    className: 'animated-loader-container'
  }, _react2['default'].createElement('div', {
    className: animatedLoaderClass
  }));
}

AnimatedPageLoader.propTypes = {
  hasBackground: _propTypes2['default'].bool
};
exports.AnimatedPageLoader = AnimatedPageLoader;